<template>
<div class="container">
<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Exam Type</div>
<div class="panal-body">



<div class="form-group">
    <label>Exam Type</label>
   <select class="form-control"  v-model="selected" @change="viewMessage" :disabled="submitted" >
  <option>select</option>
  <option v-for="exam in ExamTypes" :value="exam.serial" v-bind:key="exam.serial"> {{exam.ExamTypeNameEn}}</option>
</select>
    <small id="ExamHelp" class="form-text text-muted">We'll never share your Exam with anyone else.</small>
  </div>

   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-warning'">{{message}}</div>

<div class="text-right">
    <button type="button" class="btn btn-primary mr-1" @click="submitType" :disabled="submitted">Submit</button>
    <button type="reset" class="btn btn-success" @click="Cancel">Cancel</button>

</div>




 



</div>

</div>
</div>
</div>
</div>



</template>

<script>
import ApplicantService from '../../services/Applicant/Applicant.service'
import { BookExamTYpe } from '../../models/Applicant';
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
export default {

data(){
      return{
          selected:'',
          ExamTypes : [],
          submitted:false,
            loading: false,
            successful: false,
            message:'',
            BookExamTYpe: new BookExamTYpe('','','')
      }
  },
  created() {

  },
  computed:{
            currenUser(){
            return  this.$store.state.auth.user
          }
  },
  methods:{
      viewEquilvilant() {
          
      this.$emit('clicked', this.selected )
    }, Cancel() {
          
      this.$emit('clicked', this.selected = 0 )
    },
    viewMessage(){
        if(this.selected == 1){
            this.successful =false
            this.message = 'TOEIC Online :The booking page will show after paying exam fees '
        }else if(this.selected == 3){
            this.successful =true
            this.message = 'Equilivant Exam : You have to upload the equilivant exam certificate  '
        }
          

    },
    submitType(){

                  this.submitted = true ;

              this.BookExamTYpe.ExamTypeID = this.selected 
              this.BookExamTYpe.ApplicantID = this.currenUser.UserIDSerial
              this.BookExamTYpe.ApplicantExamID = localStorage.getItem('examId')
              ApplicantDataServices.ApplicantExam_ChangeExamType(this.BookExamTYpe).then(Response =>{
               this.ExamTypes=Response.data
               
                this.Cancel()
               
             }, 
                 error => {
               this.successful =false
               this.message =
                (error.response && error.response.data && error.response.data.Message ) ||
                error.message ||
                error.toString();
            }).then(()=>{
                
            })
          }
  },
  mounted(){
      ApplicantService.GetChangeAllExamTypes().then(Response =>{
          this.ExamTypes=Response.data
        }, error => {
             this.successful =false
              this.message =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
            })
  }
}
    
</script>

<style scoped>

table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
  
 font-size: 14px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>